import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Card, Stepper } from 'components';
import UserInfo from './UserInfo/UserInfo';
import CompanyInfo from './CompanyInfo/CompanyInfo';
import AdressInfo from './AdressInfo/AdressInfo';
import {
  updateUserInfoField,
  updateUserTypeField,
  userInfoSelector,
} from 'redux/slices/signUp/signUpSlice';
import { useRegisterMutation } from 'redux/slices/signUp/SignUpApi';
import { apiResHandler } from 'utils/axiosBaseQuery';
import PreSignUp from 'pages/Modules/Register/PreSignUp';
import { useEffect } from 'react';
import UserOperations from './UserOperations';
import {
  useLazyGetUserByIdQuery,
  useUpdateUserMutation,
} from 'redux/slices/definitions/userDefinitionApi';
import AddUser from '../AddUser/AddUser';
import { addAlertQueue } from 'redux/slices/snackbar/snackbarSlice';

const steps = [
  {
    icon: <i className="fa-solid text-primary fa-user"></i>,
    title: 'Kişisel Bilgiler',
  },
  {
    icon: <i className="fa-solid text-primary fa-building"></i>,
    title: 'Şirket Bilgileri',
  },
  {
    icon: <i className="fa-solid text-primary fa-map-location-dot"></i>,
    title: 'Adres Bilgileri',
  },
];

const CreateUser = () => {
  const [activeStep, setActiveStep] = useState(0);
  const userInfo = useSelector(userInfoSelector);

  const [formType, setFormType] = useState('');
  const [userId, setUserId] = useState('');

  const [register, { isLoading }] = useRegisterMutation();
  const [update, { isLoading2 }] = useUpdateUserMutation();
  const [getUserById, user] = useLazyGetUserByIdQuery();

  useEffect(() => {
    if (user.status === 'fulfilled') {
      Object.keys(user.data.data).forEach((key) => {
        dispatch(
          updateUserInfoField({
            field: key,
            value: user.data.data[key] ? user.data.data[key] : '',
          })
        );
      });
    }
  }, [user]);

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };
  const handlePrev = () => {
    setActiveStep(activeStep + -1);
  };

  const handleUserUpdate = () => {
    apiResHandler(
      update({ id: userId, data: userInfo }),
      () => {
        dispatch(
          addAlertQueue({
            message: 'Kullanıcı Güncellendi!',
            status: 'success',
            show: true,
          })
        );
      },
      ({ message }) => {
        dispatch(
          addAlertQueue({
            message: message,
            status: 'error',
            show: true,
          })
        );
      }
    );
  };

  const handleSignUp = () => {
    apiResHandler(
      register({ data: userInfo }),
      () => {
        dispatch(
          addAlertQueue({
            message:
              'Hesap Oluşturuldu! Onaylandıktan sonra giriş yapılabilir.',
            status: 'success',
            show: true,
          })
        );
      },
      ({ message }) => {
        dispatch(
          addAlertQueue({
            message: message,
            status: 'error',
            show: true,
          })
        );
      }
    );
  };

  const handleStep = () => {
    switch (activeStep) {
      case 0:
        return <UserOperations onNavigate={handleOperationNavigate} />;
      case 1:
        if (window.location.href.includes('kullanici-tanimlama')) {
          return <AddUser onPrev={handlePrev} />;
        } else {
          return (
            <PreSignUp
              onPrev={handlePrev}
              onNavigate={handleUserTypeNavigate}
            />
          );
        }
      case 2:
        return <UserInfo onNext={handleNext} onPrev={handlePrev} />;
      case 3:
        return (
          <CompanyInfo
            onNext={handleNext}
            onPrev={handlePrev}
            usingFromRegister={false}
          />
        );
      case 4:
        return (
          <AdressInfo
            onNext={formType === 'edit' ? handleUserUpdate : handleSignUp}
            onPrev={handlePrev}
            isLoading={formType === 'edit' ? isLoading2 : isLoading}
          />
        );
      default:
        break;
    }
  };
  const dispatch = useDispatch();

  const handleOperationNavigate = (type, id) => {
    if (type === 'new') {
      setActiveStep(1);
      setFormType('new');
    } else {
      getUserById({ id });
      setActiveStep(2);
      setFormType('edit');
      setUserId(id);
    }
  };

  const handleUserTypeNavigate = (type) => {
    dispatch(updateUserTypeField(type));
    setActiveStep(2);
  };

  return (
    <>
      <Card className="flex flex-col bg-white w-full h-70vh sm:w-full ">
        <div
          className={`flex w-full flex-col ${
            activeStep > 1 ? 'p-6' : ''
          } h-full `}
        >
          {activeStep > 1 && <Stepper activeStep={activeStep} steps={steps} />}
          {handleStep()}
        </div>
      </Card>
    </>
  );
};

CreateUser.propTypes = {};

export default CreateUser;
